import { apiClient } from './apiClient';
import { SupplierPayment, CreateSupplierPaymentRequest } from '../types';

class SupplierPaymentService {
  async getPayments(params?: {
    supplier_id?: number;
    purchase_order_id?: number;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
  }): Promise<SupplierPayment[]> {
    const response = await apiClient.get<SupplierPayment[]>('/supplier-payments', { params });
    return response;
  }

  async getPayment(id: number): Promise<SupplierPayment> {
    const response = await apiClient.get<SupplierPayment>(`/supplier-payments/${id}`);
    return response;
  }

  async createPayment(data: CreateSupplierPaymentRequest): Promise<SupplierPayment> {
    const response = await apiClient.post<{ payment: SupplierPayment }>('/supplier-payments', data);
    return response.payment;
  }

  async deletePayment(id: number): Promise<void> {
    await apiClient.delete(`/supplier-payments/${id}`);
  }
}

export const supplierPaymentService = new SupplierPaymentService();
